<div class="page-header">
    <h2>Business/Organization Selection</h2>
</div>

<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<div class="container pt-24">
    <div class="search-content">
        <!-- LEFT CONTENT -->
        <div class="left-content">
            <div class="filters-header">
            <span>Filters</span>  
            <button class="btn btn-outline-secondary btn-circle" (click)="resetFilters()" data-bs-toggle="tooltip"
  data-bs-placement="top"  title="Reset Filters">
  <i class="fa fa-filter-circle-xmark" ></i> 
</button>
            </div>
            <form [formGroup]="filterForm">
            <section>
                <div class="field">
                    <label>Business/Organization Name</label>
                    <input type="text" formControlName="companyName" maxlength="100" autofocus>
                </div>
                <div class="field">
                    <label>Industry</label>
                    <select formControlName="industry">
                        <option value="">Select</option>
                        <option *ngFor="let industry of industryList" [value]="industry.industryPk">
                            {{ industry.industryName }}
                        </option>
                    </select>                    
                </div>
                <div class="field">
                    <label>Entity Type</label>
                    <select formControlName="entityType">
                        <option value="">Select</option>
                        <option *ngFor="let entityType of entityTypeList" [value]="entityType.entityTypePk">
                            {{ entityType.entityTypeName }}
                        </option>
                    </select>                  
                </div>
                <div class="field">
                    <label>Number of Employees</label>
                    <div class="range-row">
                    <div class="col-6" style="padding: 0 0.5rem 0 0;">
                    <input type="text" formControlName="noOfEmployessFrom" inputmode="numeric" maxlength="6" (input)="onInput($event,'noOfEmployessFrom')">
                    </div><span class="hyphen">-</span><div class="col-6" style="padding: 0 0.5rem;">
                    <input type="text" formControlName="noOfEmployessTo" inputmode="numeric" maxlength="6" (input)="onInput($event,'noOfEmployessTo')">
                    </div>
                    </div>
                    <!-- <div *ngIf="filterForm.errors?.numberRangeInvalid && filterForm.touched">
                    From value must be less than or equal to To value
                    </div> -->
                </div>
                <div class="field"> 
                    <label>Signed Up Between</label>
                    <div class="range-row">
                    <div class="col-6" style="padding: 0 0.5rem 0 0;">
                    <p-datepicker appendTo="body" [maxDate]="maxDate" formControlName="createdDateFrom"
                                            showIcon="false" styleClass="w-full"></p-datepicker>
                    </div><span>-</span><div class="col-6" style="padding: 0 0.5rem;" >
                    <p-datepicker appendTo="body" [maxDate]="maxDate" formControlName="createdDateTo"
                                            showIcon="false" styleClass="w-full"></p-datepicker> 
                    </div>
                    </div>                                      
                </div>
                <div class="field">
                    <label>Business Verification Status</label>
                    <select formControlName="verificationStatus">
                        <option value="">Select</option>
                        <option *ngFor="let verificationStatus of verificationStatusList" [value]="verificationStatus.value">
                            {{ verificationStatus.name }}
                        </option>
                    </select>                  
                </div> 
                 <div class="field">
                    <label>Current Agreement Status</label>
                    <select formControlName="agreementStatus">
                        <option value="">Select</option>
                        <option *ngFor="let agreementStatus of agreementStatusList" [value]="agreementStatus.value">
                            {{ agreementStatus.name }}
                        </option>
                    </select>                  
                </div>
                <div class="field">
                    <label>Current Voucher Status</label>
                    <select formControlName="voucherStatus">
                        <option value="">Select</option>
                        <option *ngFor="let voucherStatus of voucherStatusList" [value]="voucherStatus.value">
                            {{ voucherStatus.name }}
                        </option>
                    </select>                  
                </div>
                <div class="field">
                    <label>Lead Source</label>
                    <select formControlName="leadSource">
                        <option value="">Select</option>
                        <option *ngFor="let source of leadSourceList" [value]="source.name">
                            {{ source.name }}
                        </option>
                    </select>                  
                </div>                      
            </section>
            </form>
        </div>

        <!-- RIGHT CONTENT -->
        <div class="right-content">
            <h3>Business/Organizations</h3>

            <p-table
            #dt
            responsiveLayout="scroll"
    [scrollable]="true"
    scrollDirection="horizontal"
    sortField="companyName"
    [sortOrder]="1"
    [value]="filteredList"
    [(selection)]="selectedCompany"
    selectionMode="single"
    dataKey="companyId"
    [paginator]="true"
    [rows]="10">

                <!-- Header -->
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 23%" pSortableColumn="companyName">
                            Business Name
                        <p-sortIcon field="companyName"></p-sortIcon>
                        </th>
                        <th style="width: 25%" pSortableColumn="address1">
                            Address
                        <p-sortIcon field="address1"></p-sortIcon>
                        </th>
                        <th style="width: 15%" pSortableColumn="city">
                            City
                        <p-sortIcon field="city"></p-sortIcon>
                        </th>
                        <th style="width: 12%" pSortableColumn="state">
                            State
                        <p-sortIcon field="state"></p-sortIcon>
                        </th>
                        <th style="width: 15%" pSortableColumn="zip">
                            Zip
                        <p-sortIcon field="zip"></p-sortIcon>
                        </th>
                        <th style="width: 10%" ></th>
                    </tr>
                </ng-template>

                <!-- Body -->
                <ng-template pTemplate="body" let-business>
                    <tr [pSelectableRow]="business">
                        <td>{{ business.companyName }}</td>
                        <td>{{ business.address1 + (business.address2 ? ' ' + business.address2 : '') }}</td>
                        <td>{{ business.city }}</td>
                        <td>{{ business.state }}</td>
                        <td>{{ formatZip(business.zip) }}</td>
                        <td><button type="button" class="button-open" (click)="open(business)">Select</button></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-dialog header="{{ dialogSummary }}"
    [styleClass]="dialogSummary === 'Success' ? 'success-dialog' : 'success-dialog error'" [(visible)]="modalDlg"
    [closable]="false" [closeOnEscape]="false" [modal]="true" [dismissableMask]="false" [style]="{ width: '580px' }"
    [breakpoints]="{ '640px': '95vw' }">

    <div class="dialog-body" [innerHTML]="dialogMsg"></div>

    <ng-template pTemplate="footer">
        <div class="actions">

            <!-- SUCCESS / ERROR BUTTON -->
            <ng-container>
                <button type="button" class="button-primary" (click)="okClicked()">
                    Ok
                </button>
            </ng-container>

        </div>
    </ng-template>
</p-dialog>